import $http from '../../../axios-instance';
import Swal from 'sweetalert2';
import {getAcls, validarPermisoComponente} from '../../../plugins/acl';

import VueRouter from 'vue-router';
import {dispatch} from 'rxjs/internal/observable/pairs';

/**
 * Método para confirmar la asignacion del producto.
 *
 * @param {state, commit}
 */
export async function assingProduct({commit, state}, productId) {
    const product = state.products.find(e=>e.id===productId);
    commit('setSelectedProduct', product);
}

/**
 * Método para la paginacion de los productos.
 *
 * @param {*} param0
 * @param {*} page contiene la pagina.
 */
export async function setPagePagination({commit, dispatch, state}, page) {
    commit('setPage', parseInt(page));
    await dispatch('getProductsToAssign');
}

/**
 * Método para determinar la cantidad de productos quimicos por pagina.
 *
 * @param {*} param0
 * @param {*} page contiene la pagina.
 */
export async function setPerPagePagination({commit, dispatch, state}, perPage) {
    commit('setPage',1);
    commit('setPerPage', parseInt(perPage));
    await dispatch('getProductsToAssign');
}

/**
 * Método para buscar productos quimicos reiniciando los filtros.
 *
 * @param {state, commit}
 */
export async function searchProducts({commit,dispatch, state}) {
    commit('setPage',1);
    await dispatch('getProductsToAssign');
}

/**
 * Método para reiniciar los estados principales.
 *
 * @param {state, commit}
 */
export async function resetStates({commit,dispatch, state}) {
    commit('resetFilters');
    commit('resetPaginationData');
    commit('setProducts', []);
    commit('setManufacturers', []);
    commit('setProductSelected', null);
}

/**
 * Método para obtener los productos que una empresa puede asignar.
 *
 * @param {state, commit}
 */
export async function getProductsToAssign({commit, state}) {
    commit('dashboard/load', true, {root: true});
    const acls = getAcls();
    const params = {
        company_id:acls.empresa,
        search: state.filters.search,
        manufacturer_id: state.filters.manufacturer_id,
        page: state.paginate.page,
        paginate: state.paginate.per_page
    };

    await $http.get('products/search', {params: params})
    .then((response) => {
        commit('dashboard/load', false, {root: true});
        commit('setProducts', response.data.data.data);
        commit('setPaginationData', response.data.data);
    })
    .catch(() => commit('dashboard/load', false, {root: true}));
}

/**
 * Método para obtener los productos que una empresa puede asignar.
 *
 * @param {state, commit}
 * @param productId
 */
export async function showProductInfo({commit, state}, productId) {
    commit('dashboard/load', true, {root: true});
    const acls = getAcls();
    const params = {
        company_id:acls.empresa,
        search: state.filters.search,
        manufacturer_id: state.filters.manufacturer_id,
        page: state.paginate.page,
        paginate: state.paginate.per_page
    };

    await $http.get('products/search', {params: params})
    .then((response) => {
        commit('dashboard/load', false, {root: true});
        commit('setProducts', response.data.data.data);
        commit('setPaginationData', response.data.data);
    })
    .catch(() => commit('dashboard/load', false, {root: true}));
}
